import React from 'react';
import { useNavigate } from 'react-router-dom';
import { welcome } from '../../../assets/images/formAfterSignUp';
import styles from '../FormAfterSignUp.module.css';

type TProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  username: string;
};
export default function Modal({ showModal, setShowModal, username }: TProps) {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/');
  };
  return (
    <>
      {showModal ? (
        <>
          <div className='fixed inset-0 z-10 overflow-y-auto'>
            <div
              className='fixed inset-0 w-full h-full bg-black opacity-40'
              onClick={() => setShowModal(false)}
            ></div>
            <div className='flex items-center min-h-screen px-8 py-8'>
              <div className='relative w-full max-w-sm p-6 sm:p-16 mx-auto bg-white rounded-md shadow-lg'>
                <div className='mt-3 sm:flex justify-center'>
                  <div className=' text-center sm:text-left'>
                    <div>
                      <img src={welcome} alt='welcome.png' />
                    </div>

                    <p className='mt-4 font-bold' data-testid='welcome-text'>
                      Welcome {username}!
                    </p>
                    <p className='mt-2 text-xs font-normal mb-4'>
                      Welcome onboard to TBH. Kindly check your email for the verification link and
                      your welcome pack.
                    </p>
                    <div className='items-center gap-2 mt-3 sm:flex'>
                      <button
                        onClick={() => handleClick()}
                        className={[
                          styles.bgColor,
                          'w-56 md:w-72 mt-2 p-2.5 flex-1 text-white outline-none ',
                        ].join(' ')}
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
